import { DateUtils } from '../../../common/utils/DateUtils';
import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { ReportVersion } from '../models/valueObjects/ReportVersion';

export class ReportVersionMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): ReportVersion {
    return new ReportVersion(this.gqlIdEncoder.decode(data.id), data.name, DateUtils.toMoment(data.createdAt), data.ruleset);
  }
}
